<template>
  <v-container
      class="fill-height"
      fluid>
    <v-row

        align="center"
        justify="center"
    >
      <v-col
          cols="12"
          md="6"
          lg="3"
      >
        <v-stepper v-model="step">
          <div id="assistant-header">
            <div class="assistant-header-div" v-if="step == 1"><h2>{{ $t('assistant.welcome') }}</h2></div>
            <div class="assistant-header-div" v-if="step == 2"><img src="../assets/assistant/step_1.png"></div>
            <div class="assistant-header-div" v-if="step == 3"><img src="../assets/assistant/step_2.png"></div>
            <div class="assistant-header-div" v-if="step == 4"><img src="../assets/assistant/step_3.png"></div>
            <div class="assistant-header-div" v-if="step == 5"><img src="../assets/assistant/step_4.png"></div>
            <div class="assistant-header-div" v-if="step == 6"><img src="../assets/assistant/step_5.png"></div>
            <div class="assistant-header-div" v-if="step == 7"><h2>{{ $t('assistant.done') }}</h2></div>
          </div>
          <v-stepper-header>
            <v-stepper-step
                id="assistant-step-1"
                step="1"
                color="#5fa2dd"
                :complete="step > 1">
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                id="assistant-step-2"
                step="2"
                color="#1BBC9B"
                            :complete="step > 2">
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                color="#ED5466"
                id="assistant-step-3" step="3"
                            :complete="step > 3">
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                color="#B19CD9"
                id="assistant-step-4" step="4"
                            :complete="step > 4">
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                color="#ffd351"
                id="assistant-step-5" step="5"
                            :complete="step > 5">
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                color="#6EC0E5"
                id="assistant-step-6" step="6"
                            :complete="step > 6">
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                color="#5fa2dd"
                id="assistant-step-7" step="7"
                            :complete="step > 7"

            ><img v-if="step == 7" id="assistant-finish" src="../assets/assistant/finish.png">
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <img v-if="step == 1" src="../assets/assistant/lindawave.png" id="assistant-lindawave">
            <v-stepper-content step="1" class="assistant-content-wrapper" id="asisstant-step-1">
              <v-form ref="userForm">
                <v-card class="mb-12 assistant-content">
                  <h3>{{ $t('assistant.yourName') }}</h3>
                  <v-text-field
                      id="user"
                      v-model="additionalInfo.name"
                      :rules="[rules.required]"
                      outlined
                      :label="$t('assistant.name')"
                      :placeholder="$t('assistant.namePlaceholder')"></v-text-field>
                </v-card>

                <v-btn
                    color="success"
                    @click="validateStep($refs.userForm)"
                >
                  {{ $t('assistant.next') }}
                </v-btn>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="2" class="assistant-content-wrapper">
              <v-form ref="companyForm">
                <v-card class="mb-12 assistant-content">
                    <h3>{{ $t('assistant.workFor') }}</h3>
                    <v-text-field
                        v-model="additionalInfo.company"
                        outlined
                        :rules="[rules.required]"
                        :label="$t('assistant.company')"
                        :placeholder="$t('assistant.companyPlaceholder')"></v-text-field>
                </v-card>

                <v-btn @click="step = step-1">
                  {{ $t('assistant.back') }}
                </v-btn>

                <v-btn
                    color="success"
                    @click="validateStep($refs.companyForm)"
                >
                  {{ $t('assistant.next') }}
                </v-btn>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="3" class="assistant-content-wrapper">
              <v-form ref="additionalInfoForm">
                <v-card class="mb-12 assistant-content">
                  <h3>{{ $t('assistant.moreToCompany') }}</h3>
                  <v-select outlined
                            v-model="additionalInfo.industry"
                            :items="industries"
                            :label="$t('assistant.industry')"
                            :rules="[rules.required]"
                            item-value="id">
                    <template slot="item" slot-scope="data">
                      <span class="assistant-option-item icon" :class="data.item.icon"></span>
                      <span class="assistant-option-item">{{  data.item.label }}</span>
                    </template>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.label }}
                    </template>
                  </v-select>
                  <v-select
                      outlined
                      v-model="additionalInfo.companySize"
                      :items="sizes"
                      :rules="[rules.required]"
                      :label="$t('assistant.companySize')">
                    <template slot="item" slot-scope="data">
                      <span class="assistant-option-item">{{  data.item }}</span>
                    </template>
                    <template slot="selection" slot-scope="data">
                      {{ data.item }}
                    </template>
                  </v-select>
                </v-card>

                <v-btn @click="step = step-1">
                  {{ $t('assistant.back') }}
                </v-btn>

                <v-btn
                    color="success"
                    @click="validateStep($refs.additionalInfoForm)"
                >
                  {{ $t('assistant.next') }}
                </v-btn>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="4" class="assistant-content-wrapper" id="assistant-checkbox-content">
              <v-form ref="interestsForm">
                <v-card class="mb-12 assistant-content">
                  <h3>{{ $t('assistant.want') }}</h3>
                  <v-checkbox
                      v-model="additionalInfo.interests"
                      hide-details
                      value="projects"
                      :label="$t('assistant.projectManagement')">
                  </v-checkbox>
                  <v-checkbox
                      v-model="additionalInfo.interests"
                      hide-details
                      value="tasks"
                      :label="$t('assistant.taskManagement')">
                  </v-checkbox>
                  <v-checkbox
                      v-model="additionalInfo.interests"
                      hide-details
                      value="dms"
                      :label="$t('assistant.dmsManagement')">
                  </v-checkbox>
                  <v-checkbox
                      v-model="additionalInfo.interests"
                      hide-details
                      value="activities"
                      :label="$t('assistant.activitiesManagement')">
                  </v-checkbox>
                  <v-checkbox
                      v-model="additionalInfo.interests"
                      hide-details
                      value="crm"
                      :label="$t('assistant.crmManagement')">
                  </v-checkbox>
                </v-card>

                <v-btn @click="step = step-1">
                  {{ $t('assistant.back') }}
                </v-btn>
                <v-btn
                    color="success"
                    @click="step = step+1;"
                >
                  {{ $t('assistant.next') }}
                </v-btn>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="5" class="assistant-content-wrapper">
              <v-form ref="projectForm">
                <v-card class="mb-12 assistant-content">
                  <h3>{{ $t('assistant.firstProject') }}</h3>
                  <v-text-field
                      v-model="additionalInfo.project"
                      outlined
                      :rules="[rules.required]"
                      :label="$t('assistant.project')"
                      :placeholder="$t('assistant.projectPlch')"></v-text-field>
                </v-card>

                <v-btn @click="step = step-1" class="assistant-content">
                  {{ $t('assistant.back') }}
                </v-btn>

                <v-btn
                    color="success"
                    @click="validateStep($refs.projectForm)"
                >
                  {{ $t('assistant.next') }}
                </v-btn>
              </v-form>
            </v-stepper-content>
            <v-stepper-content step="6" class="assistant-content-wrapper">
              <v-form ref="taskForm">
              <v-card class="mb-12 assistant-content">
                <h3>{{ $t('assistant.task') }}</h3>
                <v-text-field
                    outlined
                    v-model="additionalInfo.task1"
                    :rules="[rules.required]"
                    :label="$t('assistant.taskName') + ' ' + 1"
                    :placeholder="$t('assistant.taskPlch1')"></v-text-field>
                <v-text-field
                    outlined
                    v-model="additionalInfo.task2"
                    :rules="[rules.required]"
                    :label="$t('assistant.taskName') + ' ' + 2"
                    :placeholder="$t('assistant.taskPlch2')"></v-text-field>
              </v-card>

              <v-btn @click="step = step-1">
                {{ $t('assistant.back') }}
              </v-btn>
              <v-btn
                  color="success"
                  @click="validateStep($refs.taskForm)"
              >
                {{ $t('assistant.next') }}
              </v-btn>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="7" class="assistant-content-wrapper">
              <v-card class="mb-12 assistant-content">
                <span>{{ $t('assistant.toStart') }}</span>
                <div>
                  <a href="https://play.google.com/store/apps/details?id=com.phonegap.sharesuite">
                    <img src="../assets/assistant/assistant-playstore.png" id="assistant-playstore">
                  </a>
                </div>
                <div>
                  <a href="https://apps.apple.com/de/app/sharesuite/id1100115414">
                    <img src="../assets/assistant/assistant-appstore.png" id="assistant-appstore">
                  </a>
                </div>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'RegisterAssistant',
  data () {
    return {
      rules: {
        required: value => !!value || this.$t('assistant.required'),
      },
      ctxId: 0,
      additionalInfo: {
        name: '',
        company: '',
        industry: '',
        companySize: '',
        interests: [],
        project: '',
        task1: '',
        task2: ''
      },
      step: 1,
      sizes : [
        'Freelancer',
        '1-10',
        '11-20',
        '21-50',
        '51+'
      ],
      industries: [
        {
          id: '0',
          label: this.$t('assistant.industries.retail'),
          icon: 'fas fa-store'
        },
        {
          id: '2',
          label: this.$t('assistant.industries.administration'),
          icon: 'fas fa-archway'
        },
        {
          id: '1',
          label: this.$t('assistant.industries.finance'),
          icon: 'fas fa-money-bill-wave'
        },
        {
          id: '3',
          label: this.$t('assistant.industries.healthcare'),
          icon: 'fas fa-hospital'
        },
        {
          id: '4',
          label: this.$t('assistant.industries.law'),
          icon: 'fas fa-balance-scale'
        },
        {
          id: '5',
          label: this.$t('assistant.industries.media'),
          icon: 'fas fa-tv-retro'
        },
        {
          id: '6',
          label: this.$t('assistant.industries.technology'),
          icon: 'fas fa-phone-laptop'
        },
        {
          id: '7',
          label: this.$t('assistant.industries.property'),
          icon: 'fas fa-house'
        },
        {
          id: '8',
          label: this.$t('assistant.industries.other'),
          icon: 'fas fa-ellipsis-h'
        }
      ]
    }
  },
  methods: {
    validateStep(form) {
      if(form.validate()) {
        this.step++;
        if(this.step == 7) {
          this.submitAssistant();
        }
      }
    },
    submitAssistant() {
      const data = {
        name: this.additionalInfo.name,
        companyName: this.additionalInfo.company,
        initialProjectName: this.additionalInfo.project,

        initialTaskTitle: this.additionalInfo.task1,
        initialTaskTitleB: this.additionalInfo.task2,
        additionalInfos: [
          'Industry: ' + this.additionalInfo.industry,
          'Size: ' + this.additionalInfo.companySize,
          'Interests: ' + this.additionalInfo.interests.join(','),
        ]
      };
      if(this.ctxId !== 0) {
        fetch('/sharesuite/v1/web/user/register?ctxId='+ this.ctxId, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
        }
    }
  },
  created() {
    if(this.$route.params.ctxId) {
      this.ctxId = this.$route.params.ctxId;
    }
  }
}
</script>
<style scoped>
@import "../assets/font-awesome/css/all.min.css";
#assistant-mail-dialog {
  background-color: #FFF !important;
  padding: 10px;
}
#assistant-mail-dialog .v-card__text {
  color: #7e7e7e;
  font-size: 15px;
}
.v-stepper__step--active:not(.v-stepper__step--complete) .v-stepper__step__step {
  display: none !important;
}
#assistant-header {
  position: relative;
  height: 120px;
  border-bottom: 1px solid #b2b2b2;
}
.assistant-header-div {
  letter-spacing: 1px;
  color: #77b0e2;
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  align-items: center;
  justify-content: center;
}
.assistant-header-div img {
  max-width: 100%;
  position: absolute;
  bottom: 0;
  left:0;
  right:0;
  margin: auto;
}
.v-card.assistant-content {
  height: 250px;
}
img#assistant-lindawave {
  position: absolute;
  bottom: -25px;
  left: 15px;
  height: 250px;
}
img#assistant-playstore, img#assistant-appstore{
  max-width: 150px;
  margin-top: 15px;
}
img#assistant-finish {
  height: 40px;
  width: 40px;
  position: absolute;
  top: -16px;
  left: -5px;
}
.v-input--selection-controls {
  margin-top: 10px;
}
h3 {
  margin-bottom: 10px;
}
.v-btn {
  margin-bottom: 5px;
  margin-left: 10px;
}
.assistant-content-wrapper .v-stepper__content { transition: none !important;}
.v-stepper__header, .v-card.v-sheet {
  box-shadow: none;
  color: #7e7e7e;
}
.theme--light.v-card {
  background-color: transparent !important;
}
::v-deep div#assistant-step-1.v-stepper__step--active > span.v-stepper__step__step.primary {
  background-color: #000 !important;
}
.assistant-option-item {
  color: #7e7e7e !important;
}

.assistant-option-item.icon {
  margin-right: 10px;
}
::v-deep .theme--light.v-stepper .v-stepper__step__step {
  color: transparent !important;
}
::v-deep #assistant-step-7.v-stepper__step--active span.v-stepper__step__step {
  display:none;
}
::v-deep #assistant-step-7.v-stepper__step--active div.v-stepper__label {
  display: flex;
  position: relative;
  width: 24px;
  height: 24px;
 }
</style>
